import React, { Component } from "react";
import FIleProcessedSuccessSVG from "../../Assets/svg/FIleProcessedSuccessSVG.svg";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../withRouters/withRoutersHook";

class AuthenticationMessageDispatcher extends Component {
  static propTypes = {
    message: PropTypes.string,
  };
  render() {
    return (
      <div className="flex items-center gap-2 text-red-600 text-sm font-[500] font-SFPro w-full">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <span>{this.props.message}</span>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  message: state.authentication.message,
});

export default withRouterHooks(
  connect(mapStateToProps, {})(AuthenticationMessageDispatcher)
);
